<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    offset-y
    :nudge-bottom="5"
  >
    <template v-slot:activator="{ on, attrs }">
      <div
        v-bind="attrs"
        v-on="on"
        @click="resetForm"
        class="d-flex align-center justify-space-between"
        style="width: 60px;
                    padding: 3px 8px;
                    border-radius: 4px;
                    background: #eedcfd;
                    box-shadow: 0 3px 6px #794fcd29;"
      >
        <svg-icon icon-class="icon-反馈"></svg-icon>
        <span
          style="color: #333; font-weight: 400;
              font-size: 12px;">反馈</span>
      </div>
    </template>

    <v-card width="432">
      <v-card-title>
        <div class="d-flex align-center title-wrapper">
          <div>
            <v-img :src="require('@/assets/images/feedback-icon.png')" width="48" height="48"></v-img>
          </div>
          <div class="ml-2">
            <v-img :src="require('@/assets/images/feedback-share-your-wisdom.png')" width="202" height="28"></v-img>
          </div>
        </div>
      </v-card-title>

      <v-card-text class="pb-1">
        <v-form ref="feedbackForm" v-model="valid" lazy-validation>
          <v-textarea
            class="feedback-textarea"
            outlined
            dense
            name="input-7-4"
            label="Type your brilliant suggestion here…"
            rows="7"
            counter
            maxlength="2000"
            :counterValue="counterValue"
            v-model="feedbackSuggestionData.suggestion"
            :rules="inputFeedbackRules"
            auto-grow
            autofocus
            @input="suggestionChange"
            :error="error"
            :validate-on-blur="false"
          ></v-textarea>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn
          v-if="$isMobile"
          x-small
          class="submit"
          :loading="feedbackSaveLoading"
          @click="validate()"
        >
          Submit
        </v-btn>
        <v-btn
          v-else
          class="submit"
          :loading="feedbackSaveLoading"
          @click="validate()"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
import { saveFeedback } from '@/modules/chat/api'

export default {
  name: 'feedback',
  data: () => ({
    fav: true,
    menu: false,
    message: false,
    hints: true,
    valid: true,
    feedbackSaveLoading: false,
    error: false,
    feedbackSuggestionData: {
      suggestion: '',
      subject: '',
      origin: 'chatbot',
    },
    inputFeedbackRules: [],
  }),
  computed: {
    suggestionNull() {
      return !this.feedbackSuggestionData.suggestion || this.feedbackSuggestionData.suggestion === ''
    },
  },
  methods: {
    counterValue(val) {
      function convertToEmptyString(value) {
        return value === null || value === undefined ? '' : value
      }

      return (convertToEmptyString(val) + '').length
    },
    validate() {
      this.error = this.suggestionNull
      if (!this.suggestionNull) {
        this.setFeedbackSuggestion()
      }
    },
    setFeedbackSuggestion() {
      this.feedbackSaveLoading = true
      // eslint-disable-next-line no-unused-vars
      saveFeedback(this.feedbackSuggestionData).then(({ data: { data, code } }) => {
        if (code === 200) {
          this.$message.success('提交成功！')
          this.menu = false
        }
      }).finally(() => {
        this.feedbackSaveLoading = false
      })
    },
    resetForm() {
      this.error = false
      this.$refs.feedbackForm && this.$refs.feedbackForm.reset()
    },
    suggestionChange(value) {
      this.error = false
    },
  },
}
</script>
<style scoped>
.title-wrapper {
  width: 400px;
  height: 40px;
  border-radius: 8px;
  background: #faf4ff;
}

.submit {
  width: 96px;
  border-radius: 4px;
  background: linear-gradient(345.84deg, #f4e3ff 0%, #fdf 100%);
  color: #7F27D3;
}

.feedback-textarea {
  background-image: url("../../../../../../assets/images/feedback-text.png");
  background-position: right 10px center; /* 水平靠右并内缩10px，垂直居中 */
  background-size: auto 150px;
  background-repeat: no-repeat; /* 防止图像重复 */

}
</style>
